import Navbar from '../Components/Navbar';
import Pricing from '../Components/HomePageComponents/Pricing';
import 'bootstrap/dist/css/bootstrap.min.css';
//import Features from '../Components/HomePageComponents/Features';
import Banner from '../Components/HomePageComponents/Banner';
import Footer from '../Components/HomePageComponents/Footer';
import Contact from '../Components/HomePageComponents/Contact';

function HomePage() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'var(--background-color)', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Banner />
      {/* <Features /> */}
      <Pricing />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
